import styled from 'styled-components';

export const JackpotBetWidgetMobileWrapperBox = styled.div`
    margin: calc(24px + 2em) 1em 3em 1em;
    height: 50vh;
    min-height: 380px;
`;
